import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppState } from '../services';

@Component({
  selector: 'pm-page-messenger-redirect',
  templateUrl: 'messenger-redirect.html',
  styleUrls: ['./messenger-redirect.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessengerRedirectPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    const penmateId = this.route.snapshot.paramMap.get('id');
    if (!penmateId) {
      this.navCtrl.navigateRoot('/my-penmates');
      return;
    }

    const qp = this.route.snapshot.queryParams || {};
    const pathname = typeof window !== 'undefined' ? String(window.location.pathname || '') : '';
    const search = typeof window !== 'undefined' ? String(window.location.search || '') : '';

    this.store
      .select((state: any) => (state && (state as any).user ? (state as any).user.deviceInfo : null))
      .pipe(take(1))
      .subscribe((deviceInfo: any) => {
        const metrics = deviceInfo && typeof deviceInfo === 'object' ? deviceInfo.metrics : undefined;
        const isDemoUser = metrics === false;

        if (isDemoUser) {
          const prefix = `/penmates/${String(penmateId)}`;
          const rawSuffix = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
          const suffix = rawSuffix.startsWith('/') ? rawSuffix.slice(1) : rawSuffix;
          const v1Path = `${prefix}/v1${suffix ? `/${suffix}` : ''}${search || ''}`;
          this.navCtrl.navigateRoot(v1Path);
          return;
        }

        const emessage = String(qp['emessage'] || '').toLowerCase() === 'true';

        let messageType: string | null = null;
        if (emessage) {
          messageType = 'emessage';
        } else if (/new-postcard/i.test(pathname)) {
          messageType = 'postcard';
        } else if (/new-message/i.test(pathname)) {
          messageType = 'letter';
        }

        const letterIdRaw = qp['letterId'] || qp['messageId'] || qp['draftId'] || null;
        const letterId = letterIdRaw != null ? String(letterIdRaw) : null;

        const params = new URLSearchParams();
        if (messageType) params.set('messageType', messageType);
        if (letterId) params.set('letterId', letterId);

        const qs = params.toString();
        const url = `/penmates/${encodeURIComponent(penmateId)}/messenger${qs ? `?${qs}` : ''}`;
        this.navCtrl.navigateRoot(url);
      });
  }
}
